import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import API from '../BaseURL';

export default function SetupGuard({ children, mode = 'before' }) {
  const [state, setState] = useState({ loading: true, initialized: false });

  useEffect(() => {
    let alive = true;
    API.get('/setup/status')
      .then((res) => alive && setState({ loading: false, initialized: !!res.data.initialized }))
      .catch(() => alive && setState({ loading: false, initialized: false }));
    return () => { alive = false; };
  }, []);

  if (state.loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (mode === 'before') {
    return state.initialized ? <Navigate to="/login" replace /> : children;
  }
  return state.initialized ? children : <Navigate to="/setup" replace />;
}
